import(/* webpackMode: "eager" */ "/vercel/path0/src/app/features/layout.tsx");
